import { navigationCodes } from '../../../data/translations/navigationCodes';
import { NavigationTabTitleCodes } from '../types';

export const defaultTabTitleCodes: NavigationTabTitleCodes = {
	userTabTitleCode: navigationCodes.menu,
	adminTabTitleCode: navigationCodes.configuration,
};
